<template>
  <div style="width: 100%;">
    <el-row style="padding: 5px;">  
      <el-col :span="2"><el-button type="success" @click="addTableData()">{{$t('button.create')}}</el-button></el-col> 
    </el-row>   
    <el-table ref="singleTable" :data="tableData.data"  border  highlight-current-row  :empty-text="$t('msg.noDataFound')">
      <el-table-column v-for="(v, i) in tableData.columns" :prop="v.field" :label="v.title" :width="v.width" :key="i">
        <template slot-scope="scope">
          <span v-if="currentIndex==scope.$index">
            <el-input size="mini" :placeholder="$t('msg.pleaseEnterContent')"  v-model="scope.row[v.field]"></el-input>
          </span>
          <span v-else>{{ scope.row[v.field] }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('action')" width="300">
        <template slot-scope="scope">   
          <el-button v-if="currentIndex!=scope.$index" type="warning" @click="updTableData(scope.row, scope.$index, true)">{{$t('button.edit')}}</el-button>
          <el-button v-if="currentIndex==scope.$index" type="success" @click="updTableData(scope.row, scope.$index, true)">{{$t('button.confirm')}}</el-button>
          <el-button v-if="currentIndex!=scope.$index" type="danger" @click="delTableData(scope.row, scope.$index)">{{$t('button.delete')}}</el-button>    
          <el-button v-if="currentIndex==scope.$index" type="warning" @click="updTableData(scope.row, scope.$index, false)">{{$t('button.cancel')}}</el-button>                 
          <el-button v-if="currentIndex!=scope.$index && scope.row.custId != null && scope.row.custId != ''" type="primary" @click="activateAccount(scope.row, scope.$index, true)">{{$t('button.accountEnable')}}</el-button>        
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { apiFindCustWindows, apiActivateAccount } from "../../../utils/api.js";
import authHeader from "../../../services/auth-header";

export default {
  props: {    
    custId: {
      type: String
    }
  },
  data() {   
    return {    
      currentIndex:-1,
      tableData: {
        sel: null,
        columns: [
          { field: "name", title: this.$i18n.t('field.contactName'), width: 200 },         
          { field: "phone", title: this.$i18n.t('field.contactPhone') },
          { field: "email", title:this.$i18n.t('field.email') },
          { field: "address", title: this.$i18n.t('field.contactAdress')}
        ],
        data: []
      },
    };
  },   
  components: {
  },
  mounted() {
    apiFindCustWindows({ headers: authHeader(), condition:this.custId}).then((response) => {    
      if(response.data != null && response.data.length >0){
        this.tableData.data = response.data;
      }
      
    }).catch((err) => {
      console.log(err);
    });
  },
  methods: {
    addTableData() {
      if(this.currentIndex!=-1){
        return this.$message.warning({message:this.$i18n.t('msg.saveFirst'), duration: 800});
      }
      var emptyData = {};      
      this.tableData.columns.forEach((item, index) => {
        emptyData[item.field] = '';        
      });
      emptyData.action = 'A';
      this.tableData.data.splice(0, 0, emptyData);
      this.tableData.sel = JSON.parse(JSON.stringify(emptyData));
      this.currentIndex = 0;
    },
    updTableData(row, index, cg) {
      //是否是取消操作
      if (!cg) {
        if (!this.tableData.sel.email) this.tableData.data.splice(index, 1);
        return this.currentIndex = -1;;
      }     
      if(this.currentIndex !=-1 && index != this.currentIndex){
        return this.$message.warning({message:this.$i18n.t('msg.saveFirst'), duration: 800});
      } 
      if(row !=null && (row.email == null || row.email == '')){
        return this.$message.warning({message: 'email為必填', duration: 800});
      } 
      row.action = 'U';
      if (this.currentIndex !=-1 && index == this.currentIndex) {   
        // let data = JSON.parse(JSON.stringify(this.tableData.sel));
        // for (let k in data) row[k] = data[k];
        this.$refs.singleTable.setCurrentRow();       
        this.currentIndex = -1;
      } else {
        this.tableData.sel = JSON.parse(JSON.stringify(row));
        this.$refs.singleTable.setCurrentRow(row);
        this.currentIndex = index;
      }
    },
    delTableData(row, index){  
      this.$confirm(this.$i18n.t('msg.confirmDelete'), {
        confirmButtonText: this.$i18n.t('button.confirm'),
        cancelButtonText: this.$i18n.t('button.cancel'),
        type: 'warning'
      })
      .then(_ => {
        this.tableData.data.splice(index, 1);        
        done();
      })
      .catch(_ => {});
    },
    activateAccount(row, index){ 
  
      if(row.email != null && row.email != ''){
        this.$confirm(this.$i18n.t('msg.makesureActivateAccount').replace('{mail}',row.email), {
          confirmButtonText: this.$i18n.t('button.confirm'),
          cancelButtonText: this.$i18n.t('button.cancel'),
          type: 'warning'
        }).then(_ => {
          apiActivateAccount({ headers: authHeader(), condition:row.custId, condition2:row.email}).then((response) => {  
       
            if(response.data != null && response.data==true){            
              this.$message({ type: "success", message: this.$i18n.t('msg.accountEnableSuccess'), duration: 900});   
            }else{
              this.$message({ type: "error", message: this.$i18n.t('msg.accountEnableFail'), duration: 900});   
            }
          }).catch((err) => {
            console.log(err);
            this.$message({ type: "error", message: this.$i18n.t('msg.accountEnableFail'), duration: 900});  
          });       
          done();
        })
        .catch(_ => {});  
      }else{
        return this.$message.warning({message: this.$i18n.t('msg.incompleteInfo'), duration: 800});
      }
    
    }
  }
};
</script>
